
export const SELECT_ALERT = "SELECT_ALERT";

export const SELECT_ALERT_BY_ID = "SELECT_ALERT_BY_ID";

export const GET_ALERT_LOGS = "GET_ALERT_LOGS";
export const GET_ALERT_LOGS_SUCCESS = "GET_ALERT_LOGS_SUCCESS";
export const GET_ALERT_LOGS_FAIL = "GET_ALERT_LOGS_FAIL";

export const GET_ALERT_LOGS_COUNT = "GET_ALERT_LOGS_COUNT";
export const GET_ALERT_LOGS_COUNT_SUCCESS = "GET_ALERT_LOGS_COUNT_SUCCESS";
export const GET_ALERT_LOGS_COUNT_FAIL = "GET_ALERT_LOGS_COUNT_FAIL";

export const GET_INTEGRATION_TYPES = "GET_INTEGRATION_TYPES";
export const GET_INTEGRATION_TYPES_SUCCESS = "GET_INTEGRATION_TYPES_SUCCESS";
export const GET_INTEGRATION_TYPES_FAIL = "GET_INTEGRATION_TYPES_FAIL";

export const POST_ACKNOWLEDGE_ALERT = "POST_ACKNOWLEDGE_ALERT";
export const POST_ACKNOWLEDGE_ALERT_SUCCESS = "POST_ACKNOWLEDGE_ALERT_SUCCESS";
export const POST_ACKNOWLEDGE_ALERT_FAIL = "POST_ACKNOWLEDGE_ALERT_FAIL";

export const POST_RESOLVE_ALERT = "POST_RESOLVE_ALERT";
export const POST_RESOLVE_ALERT_SUCCESS = "POST_RESOLVE_ALERT_SUCCESS";
export const POST_RESOLVE_ALERT_FAIL = "POST_RESOLVE_ALERT_FAIL";

export const GET_ALERT_LOG_DETAILS = "GET_ALERT_LOG_DETAILS";
export const GET_ALERT_LOG_DETAILS_SUCCESS = "GET_ALERT_LOG_DETAILS_SUCCESS";
export const GET_ALERT_LOG_DETAILS_FAIL = "GET_ALERT_LOG_DETAILS_FAIL";

export const GET_RUNBOOK = "GET_RUNBOOK";
export const GET_RUNBOOK_SUCCESS = "GET_RUNBOOK_SUCCESS";
export const GET_RUNBOOK_FAIL = "GET_RUNBOOK_FAIL";

export const POST_RUNBOOK_FEEDBACK = "POST_RUNBOOK_FEEDBACK";
export const POST_RUNBOOK_FEEDBACK_SUCCESS = "POST_RUNBOOK_FEEDBACK_SUCCESS";
export const POST_RUNBOOK_FEEDBACK_FAIL = "POST_RUNBOOK_FEEDBACK_FAIL";

export const GET_RUNBOOK_FEEDBACKS = "GET_RUNBOOK_FEEDBACKS";
export const GET_RUNBOOK_FEEDBACKS_FAIL = "GET_RUNBOOK_FEEDBACKS_FAIL";
export const GET_RUNBOOK_FEEDBACKS_SUCCESS = "GET_RUNBOOK_FEEDBACKS_SUCCESS";

export const POST_RUNBOOK = "POST_RUNBOOK";
export const POST_RUNBOOK_FAIL = "POST_RUNBOOK_FAIL";
export const POST_RUNBOOK_SUCCESS = "POST_RUNBOOK_SUCCESS";

export const UPDATE_RUNBOOK = "UPDATE_RUNBOOK";
export const UPDATE_RUNBOOK_FAIL = "UPDATE_RUNBOOK_FAIL";
export const UPDATE_RUNBOOK_SUCCESS = "UPDATE_RUNBOOK_SUCCESS";

export const GET_ALERT_CORRELATION = "GET_ALERT_CORRELATION";
export const GET_ALERT_CORRELATION_SUCCESS = "GET_ALERT_CORRELATION_SUCCESS";
export const GET_ALERT_CORRELATION_FAIL = "GET_ALERT_CORRELATION_FAIL";

export const GET_ERROR_LOGS = "GET_ERROR_LOGS";
export const GET_ERROR_LOGS_SUCCESS = "GET_ERROR_LOGS_SUCCESS";
export const GET_ERROR_LOGS_FAIL = "GET_ERROR_LOGS_FAIL";

export const GET_METRIC_DATA_BY_ALERT_LOG_ID = "GET_METRIC_DATA_BY_ALERT_LOG_ID";
export const GET_METRIC_DATA_BY_ALERT_LOG_ID_SUCCESS = "GET_METRIC_DATA_BY_ALERT_LOG_ID_SUCCESS";
export const GET_METRIC_DATA_BY_ALERT_LOG_ID_FAIL = "GET_METRIC_DATA_BY_ALERT_LOG_ID_FAIL";

export const GET_RUNBOOK_BY_RUNBOOK_ID = "GET_RUNBOOK_BY_RUNBOOK_ID";
export const GET_RUNBOOK_BY_RUNBOOK_ID_SUCCESS = "GET_RUNBOOK_BY_RUNBOOK_ID_SUCCESS";
export const GET_RUNBOOK_BY_RUNBOOK_ID_FAIL = "GET_RUNBOOK_BY_RUNBOOK_ID_FAIL";

export const GET_RUNBOOK_RESULTS_ALERT_LOG_ID = "GET_RUNBOOK_RESULTS_ALERT_LOG_ID";
export const GET_RUNBOOK_RESULTS_ALERT_LOG_ID_SUCCESS = "GET_RUNBOOK_RESULTS_ALERT_LOG_ID_SUCCESS";
export const GET_RUNBOOK_RESULTS_ALERT_LOG_ID_FAIL = "GET_RUNBOOK_RESULTS_ALERT_LOG_ID_FAIL";


export const GET_ALERT_LOG_STATUS_HISTORY = "GET_ALERT_LOG_STATUS_HISTORY";
export const GET_ALERT_LOG_STATUS_HISTORY_SUCCESS = "GET_ALERT_LOG_STATUS_HISTORY_SUCCESS";
export const GET_ALERT_LOG_STATUS_HISTORY_FAIL = "GET_ALERT_LOG_STATUS_HISTORY_FAIL";

export const EXECUTE_RUNBOOK_STEP = "EXECUTE_RUNBOOK_STEP"
export const EXECUTE_RUNBOOK_STEP_SUCCESS = "EXECUTE_RUNBOOK_STEP_SUCCESS"
export const EXECUTE_RUNBOOK_STEP_FAIL = "EXECUTE_RUNBOOK_STEP_FAIL"


export const START_AI_CONVERSATION = "START_AI_CONVERSATION"
export const START_AI_CONVERSATION_SUCCESS = "START_AI_CONVERSATION_SUCCESS"
export const START_AI_CONVERSATION_FAIL = "START_AI_CONVERSATION_FAIL"

export const GET_AI_RESPONSE = "GET_AI_RESPONSE"
export const GET_AI_RESPONSE_SUCCESS = "GET_AI_RESPONSE_SUCCESS"
export const GET_AI_RESPONSE_FAIL = "GET_AI_RESPONSE_FAIL"

export const UPDATE_AI_RESPONSE_CHUNK = 'UPDATE_AI_RESPONSE_CHUNK';
export const SET_AI_STREAMING = 'SET_AI_STREAMING';
export const CLEAR_AI_RESPONSE = 'CLEAR_AI_RESPONSE';

export const GET_PAST_AI_CONVERSATION = "GET_PAST_AI_CONVERSATION"
export const GET_PAST_AI_CONVERSATION_SUCCESS = "GET_PAST_AI_CONVERSATION_SUCCESS"
export const GET_PAST_AI_CONVERSATION_FAIL = "GET_PAST_AI_CONVERSATION_FAIL"

export const GET_AGENT_AVAILABILITY_FOR_ALERT_LOG = "GET_AGENT_AVAILABILITY_FOR_ALERT_LOG";
export const GET_AGENT_AVAILABILITY_FOR_ALERT_LOG_SUCCESS = "GET_AGENT_AVAILABILITY_FOR_ALERT_LOG_SUCCESS";
export const GET_AGENT_AVAILABILITY_FOR_ALERT_LOG_FAIL = "GET_AGENT_AVAILABILITY_FOR_ALERT_LOG_FAIL";

export const GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID = "GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID";
export const GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID_SUCCESS = "GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID_SUCCESS";
export const GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID_FAIL = "GET_USER_EXECUTED_RESULTS_ALERT_LOG_ID_FAIL";

export const HANDLE_APPROVAL_MESSAGE = "HANDLE_APPROVAL_MESSAGE";

export const SEND_APPROVAL_DECISION = "SEND_APPROVAL_DECISION";
export const SEND_APPROVAL_DECISION_SUCCESS = "SEND_APPROVAL_DECISION_SUCCESS";
export const SEND_APPROVAL_DECISION_FAIL = "SEND_APPROVAL_DECISION_FAIL";

